<template>
  <div class="container">
    <div class="act-back">
      <div
        class="qy120"
        @click="handleGoodsClick('10887573', 'QY20231208104656356')"
      ></div>
      <div
        class="qy500"
        @click="handleGoodsClick('10887574', 'QY20231208104929797')"
      ></div>
      <div
        class="qy770"
        @click="handleGoodsClick('10887575', 'QY20231208105033717')"
      ></div>
    </div>
  </div>
</template>
<script>
import { getResourceBaseUrl, getUrlQueryValueByKey } from "@/utils/util";
import { addLog } from "../../utils/commonApi";
import { toGoodsDetail } from "../../utils/InteractionWithJs";

export default {
  data() {
    return {
      resourceBaseUrl: getResourceBaseUrl(),
    };
  },
  created() {},
  mounted() {
    document.title = "品牌活动专区";
    this.userId = getUrlQueryValueByKey(location.href, "userId") || "";
    this.token = getUrlQueryValueByKey(location.href, "token") || "";
    const accessRefer =
      getUrlQueryValueByKey(location.href, "accessRefer") || location.href;
    addLog(accessRefer, 25, "12月喷漆权益集合页");
  },
  methods: {
    handleGoodsClick(goodsId, goodsSn) {
      toGoodsDetail(2, goodsId, goodsSn);
    },
  },
  filters: {},
};
</script>
<style scoped>
.container {
  display: flex;
  flex-direction: column;
  background-color: #1d3d93;
  min-height: 100vh;
  width: 100%;
}

.act-back {
  width: 100vw;
  height: 14.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-image: url(https://zhongsheng-prod-beijing.oss-cn-beijing.aliyuncs.com/webResource/test/subject/PaintSubject1211/e06dee451cd86488.jpg);
  background-size: 100% auto;
  background-repeat: no-repeat;
}

.qy120 {
  width: 6.07rem;
  height: 2.77rem;
  background-image: url(https://zhongsheng-prod-beijing.oss-cn-beijing.aliyuncs.com/webResource/test/subject/PaintSubject1211/120.png);
  background-size: 100% auto;
  background-repeat: no-repeat;
  margin-top: 4.17rem;
}

.qy500 {
  width: 6.07rem;
  height: 2.8rem;
  background-image: url(https://zhongsheng-prod-beijing.oss-cn-beijing.aliyuncs.com/webResource/test/subject/PaintSubject1211/500.png);
  background-size: 100% auto;
  background-repeat: no-repeat;
  margin-top: 0.2rem;
}

.qy770 {
  width: 6.07rem;
  height: 2.87rem;
  background-image: url(https://zhongsheng-prod-beijing.oss-cn-beijing.aliyuncs.com/webResource/test/subject/PaintSubject1211/770.png);
  background-size: 100% auto;
  background-repeat: no-repeat;
  margin-top: 0.2rem;
}
</style>
